/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {validateSafetyNetAttestation} from '../api'

export const useMutationValidateSafetyNetAttestation = createReactQueryMutationHook('validateSafetyNetAttestation', validateSafetyNetAttestation)
